// "use client";

import { Box, CircularProgress } from "../utils/mui-imports";
import React, { useRef, Suspense } from "react";
// import { useEffect } from "react"; // Unused - no effects used
// import { SwiperSlide, Swiper } from "swiper/react"; // Unused - HeroBanner handles Swiper internally
// import "swiper/css"; // Unused - HeroBanner handles Swiper styles internally
// import { Autoplay, EffectCoverflow, EffectFade, EffectFlip } from "swiper/modules"; // Unused - HeroBanner handles Swiper modules internally
// import { FaChevronDown, FaFacebook, FaInstagram, FaPinterest } from "react-icons/fa"; // Unused - no direct icon usage
// import "swiper/css/effect-fade"; // Unused - HeroBanner handles Swiper styles internally
import { motion } from "framer-motion";
// import { useAnimate } from "framer-motion"; // Unused - no animation hook used
// import { useNavigate } from "react-router-dom"; // Unused - no direct navigation in this component
// import { getGuestId } from "../utils/guest"; // Unused - no guest handling in this component
// import { trackGAEvent } from '../utils/tracking'; // Unused - no direct tracking in this component
import LazyBrowseLooks from "./LazyBrowseLooks";

// Import HeroBanner directly (critical above-the-fold content)
import HeroBanner from "./HeroBannerNewUI";


// Lazy load auth-dependent components
const LazyCTA = React.lazy(() => {
  console.log("📦 MobileLayoutSlimUI: Lazy loading LazyCTA component...");
  return import("./LazyCTA");
});
// Lazy load other components for better performance
const Footer = React.lazy(() => import("./FooterNewUI"));


// animation variants
const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: "easeOut" }
  }
};

const MobileLayoutSlimUI = () => {
  console.log("🏠 MobileLayoutSlimUI: Component rendering started");
  
  const browseLooksSectionRef = useRef();

  const scrollToBrowseLooks = () => {
    if (browseLooksSectionRef.current) {
      const container = browseLooksSectionRef.current.parentNode;
      const elementTop = browseLooksSectionRef.current.offsetTop;
      // 10dvh → 10% of the *current* viewport height
      const headerOffset = window.innerHeight * 0.10;
      const scrollTarget = elementTop - headerOffset;
      container.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    
    }
  };

  // ✅ Auth dependencies moved to LazyCTA component for better performance
  

  // External URLs (commented out for performance - using local WebP images instead)
  // "https://images.unsplash.com/photo-1509631179647-0177331693ae?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  // "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?q=80&w=1920&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  const imageUrls = [
    "3.webp",
    "4.webp", 
    "5.webp",
  ];
  const titles = ["Imagine.", "Create.", "Shop."];

  // const [cardRef, animate] = useAnimate(); // Unused - no animation applied to any element

  // useEffect(() => { // Unused animation effect
  //   const motionAnimation = animate(
  //     cardRef,
  //     { backgroundColor: ["#ff0088", "#0d63f8"] },
  //     {
  //       duration: 2,
  //       repeat: Infinity,
  //       repeatType: "reverse",
  //       ease: "linear",
  //     }
  //   );
  //   return () => motionAnimation.cancel();
  // }, [animate, cardRef]);

  console.log("🏠 MobileLayoutSlimUI: About to render main div");
  
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100dvh",
        backgroundColor: "#ffffff",
        zIndex: 10,
        overflowY: 'scroll',
      }}
    >
      <Box sx={{ flexGrow: 1, overflowY: "scroll" }}>
        {/* Section 1: Full-height Swiper with Overlay Buttons */}
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          style={{ position: "relative", justifyContent: "center" }}
        >
          {console.log("🏠 MobileLayoutSlimUI: Rendering HeroBanner section")}
          <HeroBanner scrollToBrowseLooks={scrollToBrowseLooks} imageUrls={imageUrls} titles={titles} />
        </motion.div>

        {/* Section 2: Brows Looks Section */}
        <motion.div
          ref={browseLooksSectionRef}
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          style={{ position: "relative", justifyContent: "center" }}
        >
          {console.log("🏠 MobileLayoutSlimUI: Rendering LazyBrowseLooks section")}
          <LazyBrowseLooks showAll={false} />
        </motion.div>

        {/* Section 3: Call-to-Action Section */}
        <motion.div
          variants={sectionVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          style={{ position: "relative", justifyContent: "center" }}
        >
          {console.log("🏠 MobileLayoutSlimUI: Rendering LazyCTA section with Suspense")}
          <Suspense fallback={
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '200px',
              backgroundColor: 'white'
            }}>
              {console.log("🏠 MobileLayoutSlimUI: Showing LazyCTA Suspense fallback")}
              <CircularProgress size={24} />
            </Box>
          }>
            <LazyCTA />
          </Suspense>
        </motion.div>


        {/* Footer */}
        {console.log("🏠 MobileLayoutSlimUI: Rendering Footer section")}
        <Suspense fallback={
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100px',
            backgroundColor: 'white'
          }}>
            <CircularProgress size={24} />
          </Box>
        }>
          <Footer/>
        </Suspense>


      </Box>
    </div>
  );
};

export default MobileLayoutSlimUI;
